/**
 * Rider Sidebar Component
 *
 * Clean sidebar navigation specifically designed for riders
 * Based on deliverooAI prototype with purple gradient theme
 */

import React from "react"
import { NavLink as NavLinkRRD, useNavigate } from "react-router-dom"
import { Auth } from "../../../utils/auth"
import { removeLocalStorage } from "../../../utils/tokenstorage"
import "./rider-sidebar.css"

interface Props {
  routes: any[]
  onClose?: () => void
}

export function RiderSidebar({ routes, onClose }: Props) {
  const navigate = useNavigate()
  const userRole = Auth.role()

  // Filter routes for rider-specific navigation
  const riderRoutes = routes.filter(
    route => route.layout === "/admin" && route.permissions.includes("rider"),
  )

  const handleLogout = (event?: React.MouseEvent) => {
    if (event) event.preventDefault()
    removeLocalStorage()
    navigate("/auth/login")
  }

  return (
    <>
      {/* Logo Section */}
      <div className="rider-sidebar-logo">
        <div className="rider-sidebar-logo-content">
          <div className="rider-sidebar-logo-main">
            <img
              alt="Speedworks"
              className="rider-sidebar-logo-img"
              src={require("../../../assets/img/brand/SPEED-Logo.png")}
              style={{ height: "32px", width: "auto" }}
            />
          </div>
          {/* Close button - Only visible on mobile */}
          {onClose && (
            <button
              onClick={onClose}
              className="rider-sidebar-close"
              aria-label="Close menu"
            >
              <i className="fas fa-times"></i>
            </button>
          )}
        </div>
      </div>

      {/* User Info */}
      <div className="rider-sidebar-user">
        <div className="rider-sidebar-user-content">
          <div className="rider-sidebar-user-avatar">
            <i className="fas fa-user"></i>
          </div>
          <div className="rider-sidebar-user-info">
            <p>{Auth.username()}</p>
            <p>{Auth.role()}</p>
          </div>
        </div>
      </div>

      {/* Navigation Links */}
      <nav className="rider-sidebar-nav">
        <ul>
          {riderRoutes.map((route, index) => (
            <li key={index}>
              <NavLinkRRD
                to={route.layout + route.path}
                onClick={() => onClose && onClose()}
                className={({ isActive }) =>
                  `rider-sidebar-nav-link ${isActive ? "active" : ""}`
                }
              >
                <i className={route.icon}></i>
                <span>{route.name}</span>
              </NavLinkRRD>
            </li>
          ))}

          {/* Logout — inside nav so it's always reachable on any screen height */}
          <li className="rider-sidebar-nav-logout-item">
            <button
              onClick={handleLogout}
              className="rider-sidebar-nav-link rider-sidebar-logout-btn"
            >
              <i className="fas fa-sign-out-alt"></i>
              <span>Logout</span>
            </button>
          </li>
        </ul>
      </nav>

      {/* Footer */}
      <div className="rider-sidebar-footer">
        <p>© 2025 Speedworks Rider</p>
      </div>
    </>
  )
}
